// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1PF6B","left":"StickyBox_left__3sJS5","right":"StickyBox_right__2yvrF"};